<template>
  <div class="analytics-con">
    <div class="activity-info">
      <div class="activity-title">{{activityInfo.name}}</div>
      <div class="info-con">
        <div class="info-item">
          实践班级：{{activityInfo.class_name}}
        </div>
        <div class="info-item">
          总分：{{activityInfo.score}}
        </div>
        <div class="info-item">
          {{activityInfo.term_name}}
        </div>
        <div class="info-item">
          负责教师：{{activityInfo.teacher_names}}
        </div>
      </div>
    </div>
    <div class="analytics-title">
      活动概况
    </div>
    <div class="activity-2">
      <div class="overview-item">
        <div>
          <div class="item-title">活动总人数</div>
          <div class="item-num">{{activitySummary.num1}}</div>
        </div>

      </div>
      <div class="overview-item">
        <div>
          <div class="item-title">实际参与人数</div>
          <div class="item-num">{{activitySummary.num2}}</div>
        </div>

      </div>
      <div class="overview-item">
        <div>
          <div class="item-title">缺席人数</div>
          <div class="item-num">{{activitySummary.num3}}</div>
        </div>

      </div>
      <div class="overview-item">
        <div>
          <div class="item-title">实际完成人数</div>
          <div class="item-num">{{activitySummary.num4}}</div>
        </div>

      </div>
      <div class="chart-list">
        <div class="overview-chart">
          <div class="chart-option" id="joinOption"></div>
          <div class="chart-title">活动参与率</div>

        </div>
        <div class="overview-chart">
          <div class="chart-option" id="finishOption"></div>
          <div class="chart-title">活动完成率</div>
        </div>
      </div>

    </div>
    <div class="analytics-title">
      班级分析
    </div>
    <div class="class-content">
      <div class="class-chart">
        <div class="chart-item">
          <div class="class-join" id="classJoin"></div>
        </div>
        <div class="chart-item">
          <div class="class-score" id="classGrade"></div>
        </div>
      </div>
    </div>
    <div class="class-table">
      <table>
        <thead>
          <tr>
            <th>班级</th>
            <th>班级人数</th>
            <th>参与人数</th>
            <th>缺席人数</th>
            <th>最高分</th>
            <th>最低分</th>
            <th>平均分</th>
            <th>得分率</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in classTableInfo" :key="item.class_id">
            <td>{{item.class_name}}</td>
            <td>{{item.num1}}</td>
            <td>{{item.num2}}</td>
            <td>{{item.num3}}</td>
            <td>{{item.num4}}</td>
            <td>{{item.num5}}</td>
            <td>{{item.num6}}</td>
            <td>{{item.num7}}%</td>

          </tr>
        </tbody>
      </table>
    </div>
    <div class="analytics-title">
      成绩分析
    </div>
    <div class="score-content">
      <div class="score-table">
        <table>
          <thead>
            <tr>
              <th>分数段</th>
              <th v-for="(item,ind) in scoresInfo.scoresX" :key="ind">{{item}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,ind) in scoresInfo.scoresY" :key="ind">
              <td v-for="ele,index in item" :key="index">{{ele}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="score-chart">
        <div class="score-option" id="scoreOption"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import 'echarts-liquidfill';
import services from "../../../assets/js/services.js"
export default {
  data() {
    return {
      joinOption: {}, // 参与率
      finishOption: {}, // 活动完成率
      classJoin: {},
      classGrade: {},
      scoreOption: {},
      activityId: "",
      activityInfo: {

      },
      activitySummary: {

      },
      classList: [],
      classJoinList: [],
      classAbsentList: [],
      classHeightScoreList: [],
      classLowScoreList: [],
      classAverageScoreList: [],
      classTableInfo: [],
      scoresInfo: {}
    }
  },
  created() {
    this.activityId = this.$route.query.id
    this.getanalyticsInfo()
  },
  mounted() {

    window.addEventListener("resize", () => {
      this.joinOption.resize()
      this.finishOption.resize()
      this.classJoin.resize()
      this.classGrade.resize()
      this.scoreOption.resize()
    })
  },
  methods: {
    async getanalyticsInfo() {
      let res = await services.getAnalyticsInfo({ id: this.activityId })
      console.log(res);
      if (res.code == "0000") {
        this.activityInfo = res.data.activity
        this.activitySummary = res.data.summary
        this.classList = res.data.echarts.map((item) => {
          return item.class_name
        })
        this.classJoinList = res.data.echarts.map((item) => {
          return item.num2
        })
        this.classAbsentList = res.data.echarts.map((item) => {
          return item.num3
        })
        this.classHeightScoreList = res.data.echarts.map((item) => {
          return item.num4 * 1
        })
        this.classLowScoreList = res.data.echarts.map((item) => {
          return item.num5 * 1
        })
        this.classAverageScoreList = res.data.echarts.map((item) => {
          return item.num6 * 1
        })
        this.scoresInfo = res.data.scores
        this.classTableInfo = res.data.echarts

        this.createJoinOption();
        this.createfinishOption()
        this.createClassJoinOption()
        this.createClassGradeOption()
        this.createScoreOptionOption()
      }

    },
    setFontSize(res) {
      let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = (clientWidth / 1920);
      return res * fontSize;
    },
    // 参与率
    createJoinOption() {
      this.joinOption = echarts.init(document.getElementById('joinOption'));
      this.joinOption.setOption({
        backgroundColor: 'rgba(255,255,255,1)',
        title: {
          text: `${this.activitySummary.num5}%`,
          textStyle: {
            fontWeight: 'normal',
            fontSize: this.setFontSize(30),
            color: '#FD9F78',
          },
          top: "center",
          left: "center",
        },
        series: [
          {
            type: 'liquidFill',
            radius: '97%',
            center: ['50%', '50%'],
            data: [this.activitySummary.num5 / 100], // data个数代表波浪数
            outline: {//最外层边框设置s
              show: true,
              borderDistance: 2,//最外层挨着的白色区域
              itemStyle: {
                color: 'none',
                shadowBlur: 0,
                shadowColor: "raba(255,255,255,0)",
                borderColor: '#FFEEE7',//外边框颜色
                borderWidth: 2,//最外层宽度
              }
            },
            backgroundStyle: {
              color: 'White',       // 内部球背景颜色
              borderWidth: 0,         // 内部球边框宽度
            },
            itemStyle: {//容器内部颜色透明度等
              normal: {
                // opacity: 0.5
                shadowBlur: 0,
                shadowColor: "raba(255,255,255,0)",
                shadowOffsetY: 0,
                shadowOffsetX: 0,
              },
              emphasis: {
                disabled: false,
                color: '#FFEEE7',
              }
            },
            color: ['#FFEEE7'],  // 所有波浪一个颜色
            // color:['yellow','red','pink'], 每个波浪不同颜色，颜色数组长度为对应的波浪个数
            label: {
              normal: {
                // formatter: (0.5 * 100).toFixed(2) + '%',
                textStyle: {
                  fontSize: 0,
                  color: "rgba(255,255,255,0)"
                },
              },
            },
          },

        ],
      })

    },
    // 完成率
    createfinishOption() {
      this.finishOption = echarts.init(document.getElementById('finishOption'));
      this.finishOption.setOption({
        backgroundColor: 'rgba(255,255,255,1)',
        title: {
          text: `${this.activitySummary.num6}%`,
          textStyle: {
            fontWeight: 'normal',
            fontSize: this.setFontSize(30),
            color: "#59BFCB"
          },
          top: "center",
          left: "center",
        },
        series: [
          {
            type: 'liquidFill',
            radius: '97%',
            center: ['50%', '50%'],
            data: [this.activitySummary.num6 / 100], // data个数代表波浪数
            outline: {//最外层边框设置s
              show: true,
              borderDistance: 2,//最外层挨着的白色区域
              itemStyle: {
                color: 'none',
                shadowBlur: 0,
                shadowColor: "raba(255,255,255,0)",
                borderColor: '#E3FCFF',//外边框颜色
                borderWidth: 2,//最外层宽度
              }
            },
            backgroundStyle: {
              color: 'White',       // 内部球背景颜色
              borderWidth: 0,         // 内部球边框宽度
            },
            itemStyle: {//容器内部颜色透明度等
              normal: {
                // opacity: 0.5
                shadowBlur: 0,
                shadowColor: "raba(255,255,255,0)",
                shadowOffsetY: 0,
                shadowOffsetX: 0,
              },
              emphasis: {
                disabled: false,
                color: '#E3FCFF',
              }
            },
            color: ['#E3FCFF'],  // 所有波浪一个颜色
            // color:['yellow','red','pink'], 每个波浪不同颜色，颜色数组长度为对应的波浪个数
            label: {
              show: false,
              normal: {
                // formatter: (0.5 * 100).toFixed(2) + '%',
                textStyle: {
                  fontSize: 0,
                  color: "rgba(255,255,255,0)"
                },
              },
            },
          },

        ],
      })
    },
    createClassJoinOption() {
      this.classJoin = echarts.init(document.getElementById('classJoin'));
      this.classJoin.setOption({
        legend: {
          top: 13,
          right: 12,
          itemGap: 22,
          // left: "center",
          orient: "horizontal",
          itemWidth: 12,
          itemHeight: 4,
          icon: "roundRect",
          // borderRadius: 5
          // itemStyle: {
          //   color: "rgb(135,135,135)"
          // },
          textStyle: {
            color: "#515963",
            fontSize: this.setFontSize(13),
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: this.classList.length > 4,
            startValue: 0,
            endValue: 4,
            bottom: 10, //居下的距离
            // width: 10,
            height: 5,
            textStyle: {
              color: "#FFF",
              fontSize: 9,
            },
            fillerColor: "#EEEEEE",
            handleIcon: //两侧缩放手柄的 icon 形状，支持路径字符串
              "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5M36.9,35.8h-1.3z M27.8,35.8 h-1.3H27L27.8,35.8L27.8,35.8z", // 画一个圆形
            handleSize: "100%",
            handleStyle: {
              height: 9,
              color: "#EEEEEE",
              borderWidth: 0,
            },
            backgroundColor: "#F9F9F9", //两边未选中的滑动条区域的颜色
            showDetail: false,
            borderColor: "transparent",
            filterMode: "empty",
            brushSelect: false, // 是否开启刷选功能。在下图的 brush 区域你可以按住鼠标左键后框选出选中部分。
            zoomLock: true, // 锁定选中范围的缩放
          }
        ],
        grid: {
          bottom: "15%",
          left: 60,
          right: "5%",
        },
        xAxis: {
          type: "category",
          data: this.classList,
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#545766",
            fontSize: this.setFontSize(13),
            interval: 0,
          },
          axisLine: {
            lineStyle: {
              color: "#BFC7D0",
              opacity: 0.16,
            },
          },
        },
        yAxis: {
          type: "value",
          name: "（人数）",
          nameLocation: "start",
          nameTextStyle: {
            align: "right",
            color: "#545766",
          },
          axisLabel: {
            color: "#545766",
            fontSize: this.setFontSize(13),
          },
          splitLine: {
            lineStyle: {
              color: "#BFC7D0",
              opacity: 0.16,
            },
          },
        },
        barWidth: this.setFontSize(32),
        series: [
          {
            name: "参与人数",
            type: "bar",
            stack: "total",
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(186, 224, 243, 1)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(91, 143, 249, 1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            label: {
              show: true,
              offset: [this.setFontSize(65), 0],
              position: "inside",
              formatter: function (params) {
                return `{a|◀}{b|${params.seriesName}: ${params.value}}`;
              },
              rich: {
                a: {
                  color: "rgba(234, 244, 255, 1)",
                  lineHeight: 28,
                  padding: [0, -3, 0, 0],
                },
                b: {
                  color: "#5B8FF9",
                  fontSize: this.setFontSize(12),
                  // fontWeight: "bold",
                  padding: [this.setFontSize(8), 8],
                  backgroundColor: "rgba(234, 244, 255, 1)",
                },
              },
            },
            emphasis: {
              focus: "series",
            },
            data: this.classJoinList,
          },
          {
            name: "缺席人数",
            type: "bar",
            stack: "total",
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#fca7a5", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#ff5d5b", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            label: {
              show: true,
              offset: [this.setFontSize(65), 0],
              position: "inside",
              formatter: function (params) {
                return `{a|◀}{b|${params.seriesName}: ${params.value}}`;
              },
              rich: {
                a: {
                  color: "#fceded",
                  lineHeight: 28,
                  padding: [0, -3, 0, 0],
                },
                b: {
                  color: "#fe5e5a",
                  fontSize: this.setFontSize(12),
                  // fontWeight: "bold",
                  padding: [this.setFontSize(8), 8],
                  backgroundColor: "#fceded",
                },
              },
            },
            emphasis: {
              focus: "series",
            },
            data: this.classAbsentList,
          },
        ],
      })

    },
    createClassGradeOption() {
      this.classGrade = echarts.init(document.getElementById('classGrade'));
      this.classGrade.setOption({
        legend: {
          top: 13,
          right: 12,
          itemGap: 22,
          // left: "center",
          orient: "horizontal",
          itemWidth: 12,
          itemHeight: 4,
          icon: "roundRect",
          // borderRadius: 5
          // itemStyle: {
          //   color: "rgb(135,135,135)"
          // },
          textStyle: {
            color: "#515963",
            fontSize: this.setFontSize(13),
          },
        },
        grid: {
          bottom: "15%",
          left: 60,
          right: "5%",
        },
        xAxis: {
          type: "category",
          data: this.classList,
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#545766",
            fontSize: this.setFontSize(13),
            interval: 0,
          },
          axisLine: {
            lineStyle: {
              color: "#BFC7D0",
              opacity: 0.16,
            },
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: this.classList.length > 4,
            startValue: 0,
            endValue: 4,
            bottom: 10, //居下的距离
            // width: 10,
            height: 5,
            textStyle: {
              color: "#FFF",
              fontSize: 9,
            },
            fillerColor: "#EEEEEE",
            handleIcon: //两侧缩放手柄的 icon 形状，支持路径字符串
              "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5M36.9,35.8h-1.3z M27.8,35.8 h-1.3H27L27.8,35.8L27.8,35.8z", // 画一个圆形
            handleSize: "100%",
            handleStyle: {
              height: 9,
              color: "#EEEEEE",
              borderWidth: 0,
            },
            backgroundColor: "#F9F9F9", //两边未选中的滑动条区域的颜色
            showDetail: false,
            borderColor: "transparent",
            filterMode: "empty",
            brushSelect: false, // 是否开启刷选功能。在下图的 brush 区域你可以按住鼠标左键后框选出选中部分。
            zoomLock: true, // 锁定选中范围的缩放
          }
        ],
        yAxis: {
          type: "value",
          name: "（分数）",
          nameLocation: "start",
          nameTextStyle: {
            align: "right",
            color: "#545766",
          },
          axisLabel: {
            color: "#545766",
            fontSize: this.setFontSize(13),
          },
          splitLine: {
            lineStyle: {
              color: "#BFC7D0",
              opacity: 0.16,
            },
          },
        },
        barWidth: 32,
        series: [
          {
            name: "最高分",
            type: "bar",
            // stack: "total",
            // barGap: 1,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#ffbf99", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#fd9a5f", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            label: {
              show: true,
              offset: [50, 0],
              position: "insideTop",
              formatter: function (params) {
                return `{a|◀}{b|${params.seriesName}:${params.value}}`;
              },
              rich: {
                a: {
                  color: "#FFF0E8",
                  lineHeight: 28,
                  padding: [0, -3, 0, 0],
                },
                b: {
                  color: "#fd9a5f",
                  fontSize: this.setFontSize(12),
                  padding: [8, 12],
                  backgroundColor: "#FFF0E8",
                },
              },
            },
            emphasis: {
              focus: "series",
            },
            data: this.classHeightScoreList,
          },
          {
            name: "平均分",
            type: "bar",
            // stack: "total",
            // barGap: 1,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(186, 224, 243, 1)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(91, 143, 249, 1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            label: {
              show: true,
              offset: [50, 0],
              position: "inside",
              formatter: function (params) {
                return `{a|◀}{b|${params.seriesName}:${params.value}}`;
              },
              rich: {
                a: {
                  color: "#EAF4FF",
                  lineHeight: 28,
                  padding: [0, -3, 0, 0],
                },
                b: {
                  color: "#5B8FF9",
                  fontSize: this.setFontSize(12),
                  lineHeight: 28,
                  padding: [8, 12],
                  backgroundColor: "#EAF4FF",
                },
              },
            },
            emphasis: {
              focus: "series",
            },
            data: this.classAverageScoreList,
          },
          {
            name: "最低分",
            type: "bar",
            // stack: "total",
            // barGap: 1,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#FCA7A5", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#FF5D5B", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            label: {
              show: true,
              offset: [50, 0],
              position: "insideBottom",
              formatter: function (params) {
                return `{a|◀}{b|${params.seriesName}:${params.value}}`;
              },
              rich: {
                a: {
                  color: "#fceded",
                  lineHeight: 28,
                  padding: [0, -3, 0, 0],
                },
                b: {
                  color: "#fe5e5a",
                  fontSize: this.setFontSize(12),
                  lineHeight: 28,
                  padding: [8, 12],
                  backgroundColor: "#fceded",
                },
              },
            },
            emphasis: {
              focus: "series",
            },
            data: this.classLowScoreList,
          },
        ],
      })
    },
    createScoreOptionOption() {
      this.scoreOption = echarts.init(document.getElementById('scoreOption'));
      let series = [];
      let scoresInfo = this.scoresInfo.scoresY
      scoresInfo.forEach((item) => {
        series.push({
          name: item[0],
          type: "line",
          symbol: "circle",
          data: item.slice(1),
        });
      });
      console.log(series);

      this.scoreOption.setOption({
        color: ["#5B8FF9", "#FF6B32", "#FFB75F", "#F667D6", "#C859E8", "#F1EB4B", "#55EE63", "#5BC7F9",],
        tooltip: {
          trigger: "axis",
          borderColor: "#DEF2FF",
          extraCssText: "box-shadow: none; border-radius: 0",
          padding: [8, 20, 13, 15],
          formatter: function (params) {
            let items = ``;
            params.forEach((item) => {
              items =
                items +
                `<div style="vertical-align: middle;"><span style=" vertical-align: middle;display:inline-block;margin-right:4px;border-radius:5px;width:5px;height:5px;background-color:${item.color};"></span><span style="vertical-align: middle;">${item.seriesName}&nbsp&nbsp${item.value}人</span></div>`;
            });
            return `<div style="color: #515963; font-size: 12px;font-weight: bold;">${params[0].axisValue}</div>${items}`;
          },
        },
        legend: {
          top: 13,
          right: "2%",
          itemGap: 22,
          // left: "center",
          orient: "horizontal",
          itemWidth: 12,
          itemHeight: 4,
          icon: "roundRect",
          // borderRadius: 5
          // itemStyle: {
          //   color: "rgb(135,135,135)"
          // },
          textStyle: {
            color: "#515963",
            fontSize: 13,
          },
        },
        grid: {
          left: 50,
          right: "5%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          // boundaryGap: false,
          data: this.scoresInfo.scoresX,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#CCD5DF",
              opacity: 0.16,
            },
          },
          axisLabel: {
            color: "#545766",
            fontSize: 13,
            margin: 15,
          },
        },
        yAxis: {
          type: "value",
          name: "（分数）",
          nameLocation: "start",
          nameTextStyle: {
            align: "right",
            color: "#545766",
          },
          axisLabel: {
            color: "#545766",
            fontSize: 13,
            formatter: function (params) {
              if (Number.isInteger(params)) {
                return params;
              } else {
                return "";
              }
            },
          },
          splitLine: {
            lineStyle: {
              color: "#BFC7D0",
              opacity: 0.16,
            },
          },
        },
        series: series
      })
    }
  }
}
</script>
<style lang="less" scoped>
.analytics-con {
  overflow-y: scroll;
  height: calc(100vh - 110px);
  .activity-info {
    background-color: #fff;
    box-shadow: 0px 0px 6px 0px rgba(226, 232, 244, 0.5);
    border: 1px solid #eaf4ff;
    padding: 10px 20px 12px;
    .activity-title {
      font-weight: 400;
      font-size: 18px;
      color: #000000;
      line-height: 40px;
    }
    .info-con {
      display: flex;
      .info-item {
        font-weight: 400;
        font-size: 16px;
        color: #545766;
        line-height: 40px;
        margin-right: 5vw;
      }
    }
  }
  .analytics-title {
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 40px;
    margin-top: 3px;
  }
  .activity-2 {
    padding: 1.3vw;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(226, 232, 244, 0.5);
    border: 1px solid #eaf4ff;
    display: flex;

    .overview-item {
      padding: 0.7vw 0.7vw 1vw 1.25vw;
      border-radius: 10px;
      display: flex;
      width: 13.75vw;
      margin-right: 1.56vw;
      justify-content: space-between;
      .item-title {
        font-size: 16px;
        color: #545766;
        line-height: 40px;
      }
      .item-num {
        font-size: 24px;
        line-height: 40px;
      }
      &::after {
        content: "";
        display: block;
        width: 2.4vw;
        height: 2.4vw;
        background-size: cover;
        background-position: center;
      }
      &:nth-child(1) {
        background: #F9E9EA;
        .item-num {
          color: #ff888f;
        }
        &::after {
          background-image: url("../../../assets/image/school/analytics/overview-1.png");
        }
      }
      &:nth-child(2) {
        background: #FCEDE7;
        .item-num {
          color: #fc976e;
        }
        &::after {
          background-image: url("../../../assets/image/school/analytics/overview-2.png");
        }
      }
      &:nth-child(3) {
        background: #E0F0F7;
        .item-num {
          color: #79ccf2;
        }
        &::after {
          background-image: url("../../../assets/image/school/analytics/overview-3.png");
        }
      }
      &:nth-child(4) {
        background: #E0F3F5;
        .item-num {
          color: #75d6e2;
        }
        &::after {
          background-image: url("../../../assets/image/school/analytics/overview-4.png");
        }
      }
    }
    .chart-list {
      display: flex;
      flex: 1;
      justify-content: space-evenly;
      .overview-chart {
        .chart-option {
          width: 4.6vw;
          height: 4.6vw;
          display: 0 auto;
        }
        .chart-title {
          font-weight: 400;
          font-size: 16px;
          color: #545766;
          line-height: 40px;
          text-align: center;
        }
      }
    }
  }
  .class-content {
    .class-chart {
      display: flex;
      justify-content: space-between;
      .chart-item {
        background: #ffffff;
        box-shadow: 0px 0px 6px 0px rgba(226, 232, 244, 0.5);
        border: 1px solid #eaf4ff;
        width: calc(50% - 7px);
        height: 17.8vw;
        .class-join {
          width: 100%;
          height: 100%;
        }
        .class-score {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .class-table {
    margin-top: 15px;
    table {
      width: 100%;
      thead {
        background: #b84b3c;
        border: 1px solid #ffffff;
        tr {
          th {
            border: 1px solid #e3ebf3;
            font-size: 16px;
            color: #ffffff;
            padding: 10px 0;
            font-weight: 400;
            text-align: center;
          }
        }
      }
      tbody {
        tr {
          td {
            font-weight: 400;
            border: 1px solid #e3ebf3;
            background-color: #fff;
            padding: 14px 0;
            font-size: 16px;
            color: #545766;
            text-align: center;
          }
        }
      }
    }
  }
  .score-content {
    display: flex;
    justify-content: space-between;
    .score-table {
      width: calc(50% - 7px);
      table {
        width: 100%;
        thead {
          background: #b84b3c;
          border: 1px solid #ffffff;
          tr {
            th {
              border: 1px solid #e3ebf3;
              font-size: 16px;
              color: #ffffff;
              padding: 12px 0;
              font-weight: 400;
              text-align: center;
            }
          }
        }
        tbody {
          tr {
            td {
              font-weight: 400;
              border: 1px solid #e3ebf3;
              background-color: #fff;
              padding: 14px 0;
              font-size: 16px;
              line-height: 30px;
              color: #545766;
              text-align: center;
            }
          }
        }
      }
    }
    .score-chart {
      background: #fff;
      width: calc(50% - 7px);
      min-height: 10.8vw;
      .score-option {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>